import request from '@/utils/request'
import Vue from 'vue'

// 修改报警消息为已读
export function updateNoticeState(data) {
  return request({
    method: 'POST',
    url: Vue.prototype.alarmInfoUrl + '/business/intelligent/updateNoticeState',
    data
  })
}
// 报警信息列表
export function selectNoticePage(params) {
  return request({
    method: 'POST',
    url: Vue.prototype.alarmInfoUrl + '/business/intelligent/selectNoticePage',
    params
  })
}


